var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VouchersTableHistory',{staticClass:"pb-4",scopedSlots:_vm._u([{key:"actions",fn:function({ dataset }){return [_c('v-btn',{attrs:{"color":"secondary","data":dataset},on:{"click":_vm.exportToExcel}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-file-excel")]),_vm._v(" Exporter ")],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }